import {
  DoorStickerTemplate,
  FlyerTemplate,
  HELLOPRINT_SERVICE_LEVELS,
  PolygraphyProductType,
  StickerTemplate,
} from '../../../../../../../services/exports/Constants';
import { ProductOrderingSteps } from '../../../../../../../views/marketing/polygraphy/orders';

export default {
  title: 'Encomendar produtos impressos',
  steps: {
    [ProductOrderingSteps.ProductInfo]: 'Detalhes do produto',
    [ProductOrderingSteps.ShippingInfo]: 'Informações de envio',
    payment: 'Pagamento',
  },
  form: {
    title: 'Detalhes do pedido',
    polygraphy_product_id: {
      label: 'Produto',
      placeholder: 'Selecionar produto',
      options: {
        [PolygraphyProductType.Flyer]: {
          name: 'Folheto - {{template}}',
          templates: {
            [FlyerTemplate.One]: 'Modelo #1 🆕',
            [FlyerTemplate.Two]: 'Modelo #2 🆕',
            [FlyerTemplate.Three]: 'Modelo #3',
            [FlyerTemplate.Four]: 'Modelo #4',
          },
        },
        [PolygraphyProductType.Sticker]: {
          name: 'Autocolante - {{template}}',
          templates: {
            [StickerTemplate.One]: 'Modelo #1 🆕',
          },
        },
        [PolygraphyProductType.DoorSticker]: {
          name: 'Autocolante de porta - {{template}}',
          templates: {
            [DoorStickerTemplate.One]: 'Modelo #1 🆕',
            [DoorStickerTemplate.Two]: 'Modelo #2 🆕',
          },
        },
      },
    },
    quantity: {
      label: 'Quantidade',
      placeholder: 'Introduza a quantidade',
    },
    service_level: {
      label: 'Nível de serviço',
      options: {
        [HELLOPRINT_SERVICE_LEVELS.SAVER]: 'Económico',
        [HELLOPRINT_SERVICE_LEVELS.STANDARD]: 'Standard',
        [HELLOPRINT_SERVICE_LEVELS.EXPRESS]: 'Express',
      },
    },
    shipping_company_name: {
      label: 'Empresa',
      placeholder: 'Introduza o nome da empresa',
    },
    shipping_salutation: {
      label: 'Tratamento',
      options: {
        mr: 'Sr.',
        mrs: 'Sra.',
      },
    },
    shipping_first_name: {
      label: 'Nome próprio',
      placeholder: 'Introduza o nome próprio',
    },
    shipping_last_name: {
      label: 'Apelido',
      placeholder: 'Introduza o apelido',
    },
    shipping_country: {
      label: 'País',
      placeholder: 'Selecionar país',
    },
    shipping_state: {
      label: 'Distrito',
      placeholder: 'Selecionar distrito',
    },
    shipping_city: {
      label: 'Cidade',
      placeholder: 'Introduza a cidade',
    },
    shipping_address: {
      label: 'Morada',
      placeholder: 'Introduza a morada',
    },
    shipping_zip_code: {
      label: 'Código postal',
      placeholder: 'Introduza o código postal',
    },
    shipping_phone_number: {
      label: 'Número de telefone',
      placeholder: 'Introduza o número de telefone',
    },
    create_invoice: {
      options: {
        true: 'Faturar automaticamente - Cobrado imediatamente',
        false: 'Enviar gratuitamente - É um presente',
      },
    },
  },
  table: {
    title: 'Encomendas anteriores',
    fields: {
      product: 'Produto',
      quantity: 'Quantidade',
      status: 'Estado',
      service_level: 'Nível de serviço',
      shipping: 'Envio',
      tracking_url: 'URL de rastreio',
      created: 'Criada',
      updated: 'Última atualização',
    },
  },
  labels: {
    shipping_company: 'Empresa',
    shipping_salutation: 'Tratamento',
    shipping_first_name: 'Nome próprio',
    shipping_last_name: 'Apelido',
    shipping_address: 'Morada',
    shipping_zip_code: 'Código postal',
    shipping_city: 'Cidade',
    shipping_phone_number: 'Número de telefone',
    show_shipping_details: 'Detalhes de envio',
    track_order: 'Rastrear encomenda',
    pending_from_provider: 'Pendente do fornecedor',
  },
  modals: {
    confirmation: {
      title: 'Confirmar detalhes da encomenda',
    },
    free_order_confirmation: {
      title: 'Tem a certeza de que quer enviar {{product}} gratuitamente?',
      description: 'Optou por não cobrar o seu cliente hoje.\n O produto será enviado sem pagamento.',
      buttons: {
        confirm: 'Sim, enviar gratuitamente',
      },
    },
  },
  buttons: {
    back_to_templates: 'Voltar aos modelos',
    preview: 'Pré-visualizar',
    next: 'Seguinte',
    order: 'Criar encomenda',
    confirm: 'Confirmar',
  },
  feedback: {
    shop_url_used: 'O produto inclui o URL da loja online (<url>{{url}}</url>). É intencional?',
    order_total_price: 'Preço total dos produtos selecionados: <strong>{{amount}} NET</strong>',
  },
  toasts: {
    failed_to_create_order: 'Falha ao criar a encomenda',
    order_got_created: 'Encomenda criada com sucesso',
    failed_to_load_data: 'Falha ao carregar os dados',
  },
};
